import { render } from "./DeleteUserForm.vue?vue&type=template&id=252afa2f"
import script from "./DeleteUserForm.vue?vue&type=script&lang=js"
export * from "./DeleteUserForm.vue?vue&type=script&lang=js"
script.render = render

export default script